const MAX_SHOWN = 99;

export function UnreadBadge({ count }: { count?: number | null }) {
  if (!count) return null;

  return (
    <span className="grid place-items-center h-4 min-w-4 px-1.5 shrink-0 rounded-full bg-red-500 text-[11px] leading-none text-red-50">
      {count > MAX_SHOWN ? `${MAX_SHOWN}+` : count}
    </span>
  );
}
